export default __webpack_public_path__ + "static/media/fuds.023901df.png";